import "./App.css";
import { EnvironmentProvider } from "./utils/EnvironmentProvider";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import AppRoutes from "./AppRoutes";
import { AuthProvider } from "./utils/AuthProvider";
import { ModalStackProvider } from "./utils/ModalStackContext";
import { interceptorAPI_Calls } from "./utils/fetchInterceptor";
import { useEffect, useState } from "react";
import LoginAgain from "./components/Modal401/LoginAgain";


//Called from Index.js
function App() {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#1976D2", // Change this to your desired primary color
      },
      amber: {
        main: "#ED6C02", // Change this to your desired primary color
      },
    },
  });

  const [ showLoginModal, setShowLoginModal ] = useState(false);
  //console.log("showLoginModal", showLoginModal);
  useEffect(() => {
    // console.log("App component mounted");
    interceptorAPI_Calls(setShowLoginModal);
  }, []);

  return (
    <EnvironmentProvider>
      <ThemeProvider theme={theme}>
        <AuthProvider>
          <ModalStackProvider>
            <AppRoutes />
            {showLoginModal && <LoginAgain showLoginModal={showLoginModal} setShowLoginModal={setShowLoginModal}/>}
          </ModalStackProvider>
        </AuthProvider>
      </ThemeProvider>
    </EnvironmentProvider>
    /*
      ThemeProvider: The entire app is wrapped inside ThemeProvider to provide the Material-UI
       theme to all components.
    */
  );
}

export default App;
